import React from 'react';
import GroupIcon from 'assets/svgs/common/user-icon.svg';
import ActiveGroupIcon from 'assets/svgs/common/user-icon-white.svg';
import BootstrapSelect from 'components/CustomSelect/BootstrapSelect';
import messages from '../../messages';

const Groups = ({selected, setSelected, options}) => (
  <BootstrapSelect
    selected={selected}
    options={options}
    icon={GroupIcon}
    iconActive={ActiveGroupIcon}
    lableProp="title"
    onChange={(e) => {
      setSelected(e);
    }}
    label={messages.role}
    displaySelected
    onClear={() => {
      setSelected(null);
    }}
    enableClear
    displaySelectedValue={(e) => `${e.title}`}
    className="editor-btn "
  />
);

export default Groups;
